import Splide from '@splidejs/splide';
import splideCustomPagination from './splide/custom-pagination';
import splideCustombuttons from './splide/buttons';

const initContentThumbSlider = () => {
	const block = document.querySelector('.em-content-slider-thumbnails');

	const slides = new Splide('.em-content-slider-thumbnails__slides', {
		perPage: 1,
		pagination: true,
		arrows: false,
		slideFocus: false,
	});

	const thumbs = new Splide('.em-content-slider-thumbnails__thumbnails .splide', {
		arrows: false,
		isNavigation: true,
		perPage: 5,
		pagination: false,
		gap: 27,
		drag: false,
		mediaQuery: 'max',
		breakpoints: {
			640: {
				perPage: 3,
				drag: true,
			},
		},
	});

	splideCustomPagination(block, slides);
	splideCustombuttons(block, slides);

	slides.sync(thumbs);
	slides.mount();
	thumbs.mount();
};

initContentThumbSlider();
